import { render, staticRenderFns } from "./TheBreadcrumbs.vue?vue&type=template&id=b57fcf5e&scoped=true&"
import script from "./TheBreadcrumbs.vue?vue&type=script&lang=js&"
export * from "./TheBreadcrumbs.vue?vue&type=script&lang=js&"
import style0 from "./TheBreadcrumbs.vue?vue&type=style&index=0&id=b57fcf5e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b57fcf5e",
  null
  
)

export default component.exports